import React from 'react';
import { SESSION_FEATURE_GROUPS, mergeSessionFeatureToggles } from '../../config/sessionFeatureToggles';

const ICON_MAP = {
  showVideoTab: '🎥',
  showLiveCodeTab: '💻',
  showInteractiveTab: '🎮',
  enableLearningCards: '🃏',
  enableQuickQuiz: '🎯',
  enableQuickExercises: '⚡',
  enableMatching: '🔗',
  enableSyntaxGuess: '⌛',
  enableCodePlayground: '💻',
  enablePresentationDeck: '🖼️'
};

const SessionFeatureToggles = ({
  title = 'Session Components',
  subtitle = 'Toggle which classroom tabs and activities are available to students.',
  toggles,
  onToggleChange,
  savingState = {},
  variant = 'card'
}) => {
  const resolvedToggles = mergeSessionFeatureToggles(toggles);

  const handleChange = (key, value) => {
    if (typeof onToggleChange === 'function') {
      onToggleChange(key, value);
    }
  };

  return (
    <div className={`session-feature-toggle-panel ${variant}`}>
      {(title || subtitle) && (
        <div className="panel-heading">
          {title && <h4>{title}</h4>}
          {subtitle && <p>{subtitle}</p>}
        </div>
      )}

      <div className="feature-groups">
        {SESSION_FEATURE_GROUPS.map((group) => (
          <div key={group.label} className="feature-group">
            <div className="feature-group-header">
              <h5>{group.label}</h5>
              {group.description && <p>{group.description}</p>}
            </div>
            <div className="feature-toggle-grid">
              {group.keys.map((item) => {
                const isEnabled = Boolean(resolvedToggles[item.key]);
                const isSaving = Boolean(savingState?.[item.key]);
                return (
                  <label
                    key={item.key}
                    className={`feature-toggle ${isEnabled ? 'enabled' : 'disabled'}`}
                  >
                    <input
                      type="checkbox"
                      checked={isEnabled}
                      onChange={(e) => handleChange(item.key, e.target.checked)}
                      disabled={isSaving}
                    />
                    <span className="feature-toggle-icon" aria-hidden="true">
                      {ICON_MAP[item.key] || '🎯'}
                    </span>
                    <div className="feature-toggle-details">
                      <span className="feature-toggle-label">{item.label}</span>
                      {item.hint && (
                        <span className="feature-toggle-hint">{item.hint}</span>
                      )}
                    </div>
                    <span className="feature-toggle-state">
                      {isSaving ? 'Saving...' : isEnabled ? 'On' : 'Off'}
                    </span>
                  </label>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SessionFeatureToggles;
